module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scrollTop",
    on: {
      "click": _vm.scrollTop
    }
  }, [_vm._v("\n\tTop\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9a3f6ae0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scolltotop.vue
// module id = 208
// module chunks = 1